
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { switchMap, map } from 'rxjs/operators';
import { StockTransferData } from '../../../interfaces/pharmacy/stockTransfer';
import { StockTransferApi } from '../api/stockTransfer.api';


@Injectable()
export class StockTransferService extends StockTransferData {

  constructor(private api: StockTransferApi) {
    super();
  }


  list(url: string): Observable<any[]> {
    return this.api.list(url);
  }
alertMinList(url: string): Observable<any[]> {
    return this.api.minList(url);
  }
  excessMaxList(url: string): Observable<any[]> {

    return this.api.maxList(url);
  }
  getById(url:string): Observable<any>{
      return this.api.getById(url);
  }

  create(url: string, data:any): Observable<any> {
    return this.api.add(url,data);
  }
  //
  stockcreate(url: string, data:any): Observable<any> {
    return this.api.stockadd(url,data);
  }
  stockAdjustmentcreate(url: string, data:any): Observable<any> {
    return this.api.stockAdjustmentadd(url,data);
  }
  //

  update(url: string, data:any): Observable<any> {
    return this.api.update(url,data);
  }

  searchList(url: string,data:any): Observable<any> {

    return this.api.searchList(url,data);
  }
  closingStockList(url: string): Observable<any[]> {

    return this.api.closingStockList(url);
  }
  delete(url: string): Observable<boolean> {
    return this.api.delete(url);
  }
}
